import { Trash2, Briefcase } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useDeleteExperience } from '@/hooks/use-profile';
import type { WorkExperience } from '@/hooks/use-profile';

interface ExperienceSectionProps {
  experience: WorkExperience[];
}

export function ExperienceSection({ experience }: ExperienceSectionProps) {
  const deleteExp = useDeleteExperience();

  if (experience.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-sm">
            <Briefcase className="h-4 w-4" />
            Work Experience
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            No work experience yet. Upload a CV to extract your history.
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-sm">
          <Briefcase className="h-4 w-4" />
          Work Experience ({experience.length})
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {experience.map((exp, index) => (
            <div
              key={index}
              className="group flex items-start justify-between rounded-lg border p-3"
            >
              <div className="flex-1">
                <p className="text-sm font-medium">{exp.title}</p>
                <p className="text-xs text-muted-foreground">{exp.company}</p>
                {(exp.startDate || exp.endDate) && (
                  <p className="mt-0.5 text-xs text-muted-foreground">
                    {exp.startDate ?? '?'} — {exp.endDate ?? 'Present'}
                  </p>
                )}
                {exp.description && (
                  <p className="mt-1 text-xs text-muted-foreground line-clamp-2">
                    {exp.description}
                  </p>
                )}
              </div>
              <Button
                size="sm"
                variant="ghost"
                className="hidden group-hover:flex"
                onClick={() => deleteExp.mutate(index)}
              >
                <Trash2 className="h-3.5 w-3.5 text-red-500 dark:text-red-400" />
              </Button>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
